// owner/ui/PlatformMark.js — a platform's own logo in a small round badge, and its name.
// Logos and names come from the one shared source, utils/platformUtils.js (house rule: no local platform maps).
// The logo files are served from /images/ — web/public/images on the web, web/public-owner-app/images in the app.

import React from 'react';
import { getPlatformLogo, getPlatformDisplayName } from '../../utils/platformUtils';
import useLanguage from '../../hooks/useLanguage';

const DIRECT = new Set(['direct', 'manual', 'hostme']);

export const usePlatformName = () => {
  const { t } = useLanguage();
  return (platform) => {
    const key = (platform || '').toLowerCase();
    // Direct bookings get a translated name; platformUtils writes it in Arabic only. Brand names stay as written.
    if (DIRECT.has(key)) return t('ownerApp.common.directBooking');
    return getPlatformDisplayName(platform) || platform;
  };
};

const PlatformMark = ({ platform, withName = false }) => {
  const nameOf = usePlatformName();
  const logo = getPlatformLogo(platform);
  const name = nameOf(platform);
  const badge = (
    <span className="o-pm" title={withName ? undefined : name}>
      {logo ? <img src={logo} alt={withName ? '' : name} /> : null}
    </span>
  );
  if (!withName) return badge;
  return (
    <span className="o-platform">
      {badge}
      <span className="o-ltr">{name}</span>
    </span>
  );
};

export default PlatformMark;
